import { useI18n } from 'next-localization';

import { useFormatedSiteTitle } from '@/hooks/use-formatted-site-title';
import { cn } from '@/lib/utils';

import styles from '../listing.module.css';
import { SortByFilter } from './filters/sort-by';

export const ListHeader = ({
  totalResults,
  startResults,
  endResults,
  hasDistance,
  isLoading,
  isPhysicians,
  totalProvidersCount,
}: {
  totalResults: number;
  startResults: number;
  endResults: number;
  hasDistance: boolean;
  isLoading?: boolean;
  isPhysicians?: boolean;
  totalProvidersCount: number;
}): JSX.Element => {
  const { t } = useI18n();

  const pageTitle = useFormatedSiteTitle({ returnType: 'string' });

  return (
    <div className={cn('container', isPhysicians && 'pt-3', styles.listHeaderWrapper)}>
      <div className="row">
        <div
          role="region"
          aria-labelledby="landing-page-title"
          className={cn('col-sm-12 col-md-8 col-lg-9 justify-content-start', styles.listHeader)}
        >
          <h5 className={cn('fw-bold', styles.listHeaderResults)}>
            {pageTitle ? `${t('OAS.Listing.ResultsFor')} ${pageTitle}` : t('Search.Result.Results')}
          </h5>
          <p>
            {totalResults === 0 && !isLoading ? (
              <span> {t('OAS.Listing.ShowingResults', { number: 0 })}</span>
            ) : (
              <span>
                {isLoading
                  ? '...'
                  : t('OAS.Listing.DisplayingResults', {
                      startResults,
                      endResults,
                      totalResults,
                    })}
              </span>
            )}
          </p>
        </div>
        <SortByFilter hasDistance={hasDistance} totalProvidersCount={totalProvidersCount} />
      </div>
    </div>
  );
};
